import {
  Outlet,
  useLocation,
  useMatch,
  useSearchParams,
} from "react-router-dom";

import { Box, Stack } from "@mui/material";

import Header from "../Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../Footer";
import useCountries from "../../hooks/useCountries";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useEffect } from "react";
import UserConfirmation from "./partials/UserConfirmation/UserConfirmation";
import ResetPassword from "./partials/ResetPassword/ResetPassword";

const Layout = () => {
  const { pathname } = useLocation();
  const { getCountries } = useCountries();
  const [searchParams, setSearchParams] = useSearchParams();
  const { login } = useAuthContext();

  const isVerificationRoute = useMatch("/verification");
  const isResetRoute = useMatch("/reset-password");
  const isGetStartedUploadRoute = useMatch("/dashboard/get-started/upload");

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = params.get("access_token");

    if (accessToken) {
      login({
        access_token: accessToken,
        refresh_token: "",
        refresh_token_expires_at: 3600 * 24 * 6,
        expires_in: 7200,
        token_type: "Bearer",
      });

      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [login]);

  if (!pathname) return null;

  return (
    <Stack height="100vh" overflow="hidden">
      <Header />
      <Stack
        overflow="hidden"
        direction="row"
        flex={1}
        sx={{ minWidth: 0, minHeight: 0 }}
      >
        <Stack sx={{ minWidth: 0, minHeight: 0 }}>
          <Sidebar />
        </Stack>
        <Stack flex={1} sx={{ minWidth: 0, minHeight: 0 }}>
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              display: "flex",
            }}
          >
            <Stack direction="row" justifyContent="center" flex={1}>
              <Outlet />
            </Stack>
          </Box>
          {!isGetStartedUploadRoute && <Footer />}
        </Stack>
      </Stack>
      {searchParams.get("token") &&
        searchParams.get("email") &&
        isVerificationRoute && <UserConfirmation />}
      {searchParams.get("token") &&
        searchParams.get("email") &&
        isResetRoute && <ResetPassword />}
    </Stack>
  );
};

export default Layout;
